import localforage from 'localforage';

import { queryClient } from '@moniebook-web/utils';

import { PAGES, SEARCH_TERMINATE_REASON } from './constants';
import { removeAllCookies } from './cookies';
import { clearExistingData } from './db/utils';
import { logger } from './log';
import { searchService } from './services';
import {
    SEARCH_INDEX_STATUS,
    useBackgroundItemSyncStore,
    useBusinessStore,
    useCartStore,
    useRegisterConfiguration,
    useSearchIndexStore,
    useStaffSessionStore,
    useSubscriptionStore,
} from './store';

import type { NavigateFunction } from 'react-router-dom';

export async function clearUserInfo() {
    removeAllCookies();

    useBackgroundItemSyncStore.getState().reset();
    useBusinessStore.getState().reset();
    useStaffSessionStore.getState().reset();
    useRegisterConfiguration.getState().reset();
    useSubscriptionStore.getState().reset();
    useCartStore.getState().resetCart();

    queryClient.clear();

    await localforage.clear();
    await clearExistingData();

    useSearchIndexStore.getState().setStatus(SEARCH_INDEX_STATUS.Idle);
    searchService.terminateWorker(SEARCH_TERMINATE_REASON.UNPAIR);
}

export async function unpairAndClearUserInfo(navigate?: NavigateFunction) {
    logger.info(
        `[UNPAIR]: Register unpairing triggered: ${globalThis.location.href}`,
    );

    await clearUserInfo();

    if (navigate) {
        navigate(PAGES.ONBOARDING.LANDING);
        return;
    }

    window.location.href = PAGES.ONBOARDING.LANDING;
}
